<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <b-row v-if="width <= 900">
        <span style="color: #0069A9; font-weight: 600; text-align: left">Expediente clínico electrónico</span>
        <b-col v-if="blnActivar" class=" contenedorTablaSinColor col-12" style="background: #fffefe !important;">
          <div class="text-right mr-2 mt-1" v-if="blnActivar">
<!--            <b-button
                class="mr-2 shadow-botones menu-directorio"
                pill
                variant="light"
                size="sm"
                @click="blnActivar = !blnActivar"
                style="color: #0069a9;"
            >
              <font-awesome-icon icon="arrow-right"/>
            </b-button>-->
          </div>
          <div class="ml-4">
          <!--AQUI VA EL DIRECTORIO-->
          <DirectorioEce
              @ruta="obtenerRutaSeleccionadaMovil"
              :activarBlnDirectorio="blnActivar"
              @obtenerBlnDirectorio="obtenerBlnDirectorio"
          ></DirectorioEce>
          </div>
        </b-col>
        <b-col v-else class="col-12">
          <ExploradorArchivoExpedienteV2
              :rutaSeleccionada="RutaBase"
              ref="exploradorArchivo"
              :idPacienteArchivos="idPaciente"
              :activarBlnDirectorio="blnActivar"
              @obtenerBlnDirectorio="obtenerBlnDirectorio"
          ></ExploradorArchivoExpedienteV2>
        </b-col>
      </b-row>
        <b-row v-else>
          <b-col class="col-3" style="background: #fffefe !important;">
            <div class="directorio text-left mt-3 mb-4">
              <span style="color: #0069A9; font-weight: 600;">Expediente clínico electrónico</span>
            </div>
            <div class="contenedorTablaSinColor mt-4">
              <DirectorioEce
                  @ruta="obtenerRutaSeleccionada"
                  :activarBlnDirectorio="blnActivar"
                  @obtenerBlnDirectorio="obtenerBlnDirectorio"
              ></DirectorioEce>
            </div>
          </b-col>
          <b-col class="col-9" >
                <ExploradorArchivoExpedienteV2
                  :rutaSeleccionada="RutaBase"
                  ref="exploradorArchivo2"
                  :idPacienteArchivos="idPaciente"
                  :activarBlnDirectorio="blnActivar"
                  @obtenerBlnDirectorio="obtenerBlnDirectorio"
                ></ExploradorArchivoExpedienteV2>
          </b-col>
        </b-row>
    </div>
</template>
<script>
import ExploradorArchivoExpedienteV2
  from "@/views/ExpedienteDigitalPaciente/ExploradorArchivos/ExploradorArchivoExpedienteV2.vue";
import DirectorioEce from "@/views/EceV2/DirectorioEce";

export default {
  name: "ExpedienteDigital",
  components: {
    ExploradorArchivoExpedienteV2,
    DirectorioEce
  },
  props: {
    idPacienteExp:null,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    RutaBase: null,
    RutaBase2: [],
    blnActivar: true,
    width:0,
    height: 0,
    idPaciente: null,
  }),

  
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idPaciente =  this.idPacienteExp;
    this.width = window.innerWidth;
    this.height = window.innerHeight;
  },
  methods: {
    obtenerRutaSeleccionadaMovil(value) {
      this.RutaBase2 = [];
      this.blnActivar= false;
      this.RutaBase = value.replace("#id_paciente", this.idPaciente);
      let textoSeparado = this.RutaBase.split("/");
      textoSeparado.forEach((element) => {
        if (element !== "pacientes" && element !== this.idPaciente && element !== "") {
          this.RutaBase2.push({text:element});
        }
      });
      setTimeout(() => {
        this.$refs.exploradorArchivo.obtenerArchivos(this.RutaBase,this.RutaBase2);
      }, 100);
    },
    obtenerRutaSeleccionada(value) {
      this.RutaBase2 = [];
      this.blnActivar= false;
      this.RutaBase = value.replace("#id_paciente", this.idPaciente);
      let textoSeparado = this.RutaBase.split("/");
      textoSeparado.forEach((element) => {
        if (element !== "pacientes" && element !== this.idPaciente && element !== "") {
          this.RutaBase2.push({text:element});
        }
      });
      this.$refs.exploradorArchivo2.obtenerArchivos(this.RutaBase,this.RutaBase2);
    },
    obtenerBlnDirectorio(value){
     this.blnActivar = value;
    }
  },
};
</script>

<style scoped>
.contenedorTablaSinColor {
  height: 96vh !important;
}
</style>
